import axiosWithToken from "axiosWithToken";
const baseURL2 = process.env.REACT_APP_BASEURL2;

export const getUserDetails = async () => {
  try {
    const response = await axiosWithToken.get(`${baseURL2}api/auth/user`);
    if (response.data) {
      localStorage.setItem("user", JSON.stringify(response.data));
    }
  } catch (error) {
    console.error("Error fetching user details:", error);
    throw error;
  }
};
